import React, { useCallback, useState } from "react";
import ReactPlayer from "react-player/lazy";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { styled } from "@mui/material/styles";

// Styled components
const PlayerWrapper = styled("div")({
  position: "relative",
  paddingTop: "56.25%", // 16:9 aspect ratio
});

const StyledReactPlayer = styled(ReactPlayer)({
  position: "absolute",
  top: 0,
  left: 0,
});

const Player = (props) => {
  const [show, setShow] = useState(true);

  const handleChange = useCallback(() => {
    setShow((v) => !v);
  }, []);

  return (
    <>
      {show && (
        <PlayerWrapper>
          <StyledReactPlayer
            controls
            url={props.url}
            config={{
              youtube: {
                playerVars: { showinfo: 1 },
              },
              facebook: {
                appId: `${process.env.REACT_APP_FACEBOOK_APP_ID}`,
              },
            }}
            muted
            playing
            width="100%"
            height="100%"
          />
        </PlayerWrapper>
      )}
      <FormGroup row>
        <FormControlLabel
          control={
            <Switch checked={show} onChange={handleChange} name="show-video" />
          }
          label="Show video"
        />
      </FormGroup>
    </>
  );
};

export default Player;
